{
  "greeting": "こんにちは！ワインについてどのようにお手伝いできますか？",
  "thinking": "✨ 考え中...",
  "thinkingStep": "✨ あなたにぴったりのワインを見つけています…🍷",
  "askAboutWine": "例: 1990年代のボルドー赤 約$1500 | ブルゴーニュ村名白 $600以下",
  "askAboutWineFirst": "購入したい（地域 + 色 + ヴィンテージ + 予算）",
  "waitingForResponse": "応答を待っています...",
  "dailyLimitReached": "1日のアドバイス回数の上限に達しました。HKT 00:00以降にお戻りください。",
  "chatHistory": "チャット履歴",
  "noChatHistory": "チャット履歴はまだありません",
  "startConversation": "会話を始めるとここに表示されます",
  "backToChat": "チャットに戻る",
  "newChat": "新しいチャット",
  "history": "履歴",
  "search": "検索",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "ワインアドバイザー",
  "chat": "チャット",
  "chatNumber": "チャット {number}",
  "wineRecommended": "{count}本のワインをおすすめ",
  "winesRecommended": "{count}本のワインをおすすめ",
  "justNow": "たった今",
  "minuteAgo": "{count}分前",
  "minutesAgo": "{count}分前",
  "hourAgo": "{count}時間前",
  "hoursAgo": "{count}時間前",
  "dayAgo": "{count}日前",
  "daysAgo": "{count}日前",
  "noMessagesYet": "メッセージはまだありません",
  "perBottle": "1本あたり",
  "priceNA": "価格未定",
  "buyNow": "今すぐ購入",
  "moreInformation": "詳細情報",
  "share": {
    "button": "共有",
    "title": "会話を共有",
    "description": "以下のリンクを使って、この会話を友達と共有してください：",
    "generating": "共有リンクを生成中...",
    "error": "共有リンクの生成に失敗しました",
    "copy": "コピー",
    "copied": "コピーしました！",
    "note": "注意：このリンクは30日後に期限切れになります。誰かがこのリンクを開くと、この会話のコピーが表示されます。"
  },
  "checkOutWine": "このワインをチェック: {name} {vintage}",
  "linkCopied": "リンクがクリップボードにコピーされました！",
  "contactWhatsApp": "その他のオプションについてはWhatsAppでお問い合わせください",
  "errorLoadingWine": "申し訳ありません。ワインの詳細を読み込めませんでした。",
  "errorOccurred": "応答の取得中にエラーが発生しました。",
  "you": "あなた",
  "welcome": {
    "intro": "WWXへようこそ。AIワインアドバイザーのZyraです。以下にアクセスできます：",
    "features": {
      "globalMarket": "グローバル高級ワイン市場（UK、FR、HKセラー）",
      "realTimeOffers": "ご予算内のリアルタイムベストオファー",
      "personalized": "あなただけのパーソナライズされたおすすめ",
      "comparison": "ヴィンテージとブランドの簡単比較",
      "instantCheckout": "数量と配送の即時チェックアウト"
    },
    "question": "今日は何をおすすめしましょうか？",
    "trendingPrompts": "リクエスト例",
    "promptExamples": {
      "title": "質問の仕方：",
      "good": "✓ 良い例：",
      "bad": "✗ 予算なしのリクエストは避けてください："
    },
    "prompts": {
      "bordeaux": "ボルドー赤 約$800",
      "champagne": "グロワーシャンパーニュ $2000以下",
      "firstGrowth": "ファーストグロース 2010-2019 ベストオファー"
    }
  },
  "feedback": {
    "helpful": "役に立ちました",
    "notHelpful": "役に立ちませんでした",
    "thankYou": "フィードバックありがとうございます！",
    "whatDidYouLike": "何が良かったですか？",
    "whatCouldBeImproved": "何を改善できますか？",
    "category": "カテゴリー",
    "selectCategory": "カテゴリーを選択",
    "categories": {
      "accuracy": "正確さ",
      "helpfulness": "有用性",
      "responseSpeed": "応答速度",
      "clarity": "明瞭さ",
      "other": "その他"
    },
    "comments": "コメント",
    "placeholder": "体験について詳しくお聞かせください...",
    "cancel": "キャンセル",
    "submit": "フィードバックを送信",
    "submitting": "送信中..."
  },
  "auth": {
    "limitReached": "1日の上限に達しました",
    "signUpToday": "メッセージを増やすには登録してください",
    "limitMessage": "1日のメッセージ上限に達しました。無料アカウントに登録してチャットを続けてください。",
    "benefitsMessage": "無料アカウントを作成して、チャットを続けたり、デバイス間でチャット履歴を保存したりしましょう。",
    "remainingMessages": "本日の残りメッセージ数：{count}",
    "signUp": "登録",
    "login": "ログイン",
    "loggedInAs": "{email}でログイン中",
    "logout": "ログアウト"
  }
}
